import { cn } from "@u/cn";
import { AlertCircle } from "lucide-react";

type AuthErrorProps = {
  children: React.ReactNode;
  className?: string;
};

/**
 * Server-error banner for the auth surfaces (login / register / recover) — the
 * non-RHF errors that live outside `FormMessage`. Single source for the markup
 * that was copy-pasted ~5×. Carries the correct a11y (`role="alert"` +
 * `aria-live="assertive"`) so every call site announces the error, not just the
 * ones that remembered to add it.
 */
export function AuthError({ children, className }: AuthErrorProps) {
  return (
    <div
      role="alert"
      aria-live="assertive"
      className={cn(
        "flex items-center gap-3 rounded-2xl border border-destructive/30 bg-destructive/10 px-4 py-3 text-xs uppercase tracking-tight text-destructive animate-in shake duration-300",
        className,
      )}
    >
      <AlertCircle size={16} className="shrink-0" />
      {children}
    </div>
  );
}
